module.exports = __webpack_public_path__ + "img/header-weddingRingsForestGreen.85dd650.webp";